import { Badge, fmt, RelativeTime, type Column } from "@nabble/ui";
import { DEFAULT_ORGANIZATION_ID, type Organization } from "../../../api/adminOrganizations";

export interface OrganizationColumnsInput {
  /** Whether the signed-in administrator belongs to the organization. */
  belongsTo: (organization: Organization) => boolean;
  rename: (organization: Organization) => void;
  remove: (organization: Organization) => void;
}

/** The columns of the organizations list; only empty organizations can be deleted, never the first one. */
export function organizationColumns({ belongsTo, rename, remove }: OrganizationColumnsInput): Column<Organization>[] {
  return [
    {
      key: "name",
      label: "Organization",
      minWidth: 260,
      render: (o) => (
        <strong title={o.name}>
          {o.name}
          {belongsTo(o) ? (
            <>
              {" "}
              <Badge label="You belong" tone="info" dot={false} />
            </>
          ) : null}
        </strong>
      ),
    },
    { key: "users", label: "People", type: "number", width: 112 },
    {
      key: "createdAt",
      label: "Created",
      type: "datetime",
      width: 150,
      text: (o) => fmt.dateTime(o.createdAt),
      render: (o) => <RelativeTime value={o.createdAt} />,
    },
    {
      key: "actions",
      label: "Actions",
      type: "actions",
      width: 92,
      actions: (o) => [
        { label: `Rename ${o.name}`, icon: "edit", inline: true, onSelect: () => rename(o) },
        {
          label: "Delete organization",
          icon: "trash",
          tone: "danger",
          onSelect: () => remove(o),
          disabled: o.users > 0,
          hidden: o.id === DEFAULT_ORGANIZATION_ID,
        },
      ],
    },
  ];
}
